var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAkamaiLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "svg834",
    xmlSpace: "preserve",
    width: 409.33292,
    height: 166.75058,
    viewBox: "0 0 409.33292 166.75058",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs838"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath852"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 612 V 792 H 0 Z",
    id: "path850"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath860"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m -749.369,-45.4393 h 2 v -58.7847 h -2 z",
    id: "path858"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath1256"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 36,391.52 H 304.229 V 271.475 H 36 Z",
    id: "path1254"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath1368"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 612 V 792 H 0 Z",
    id: "path1366"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath1396"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 612 V 792 H 0 Z",
    id: "path1394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath1432"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 612 V 792 H 0 Z",
    id: "path1430"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g842",
    transform: "matrix(1.3333333,0,0,-1.3333333,-237.09597,1002.4343)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1518",
    transform: "matrix(4.2054927,0,0,4.2054927,-1937.8449,-2419.1027)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1392",
    clipPath: "url(#clipPath1396)",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g1557"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#0099cc",
      fillOpacity: 1
    },
    transform: "translate(518.1763,724.9189)",
    id: "g1402"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1404",
    style: {
      fill: "#0099cc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c -6.127,1.862 -10.58,7.517 -10.58,14.209 0,6.763 4.548,12.465 10.768,14.279 0.637,0.189 0.472,0.59 -0.306,0.59 -8.271,0 -14.986,-6.669 -14.986,-14.869 0,-8.2 6.715,-14.869 14.986,-14.869 C 0.66,-0.66 0.707,-0.212 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000"
    },
    transform: "translate(510.4474,735.6639)",
    id: "g1406"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1408",
    style: {
      fill: "#0099cc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c -0.047,0.401 -0.071,0.801 -0.071,1.202 0,6.527 5.279,11.805 11.806,11.805 6.173,0 8.011,-2.757 8.247,-2.568 0.259,0.188 -2.239,5.655 -9.473,5.655 -6.527,0 -11.805,-5.278 -11.805,-11.805 0,-1.508 0.283,-2.946 0.801,-4.265 C -0.283,-0.542 0.047,-0.542 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#0099cc",
      fillOpacity: 1
    },
    transform: "translate(515.3958,744.1704)",
    id: "g1410"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1412",
    style: {
      fill: "#0099cc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 3.063,1.343 6.928,1.39 10.721,0.047 2.545,-0.895 4.03,-2.168 4.148,-2.097 0.212,0.094 -1.485,2.757 -4.525,3.912 C 6.668,3.252 2.71,2.521 -0.165,0.259 -0.495,0 -0.377,-0.165 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#ff9933",
      fillOpacity: 1
    },
    transform: "translate(576.072,738.6094)",
    id: "g1414"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1416",
    style: {
      fill: "#ff9933",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,-0.848 -0.707,-1.555 -1.555,-1.555 -0.849,0 -1.555,0.683 -1.555,1.555 0,0.848 0.683,1.555 1.555,1.555 C -0.683,1.555 0,0.872 0,0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path1420",
    style: {
      fill: "#ff9933",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 525.4574,729.9144 0.188,-2.074 h 3.276 l -1.108,12.041 h -4.877 l -6.174,-12.041 h 3.346 l 1.037,2.074 z m -0.165,2.333 h -2.993 l 2.569,5.207 h 0.023 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1424",
    style: {
      fill: "#ff9933",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 533.469,733.0956 h 0.495 l 2.333,3.181 h 3.039 l -3.228,-4.053 1.98,-4.383 h -3.229 l -1.296,3.417 h -0.471 l -0.73,-3.417 h -2.757 l 2.544,12.041 h 2.757 z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#ff9933",
      fillOpacity: 1
    },
    clipPath: "url(#clipPath1432)",
    id: "g1428"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#ff9933",
      fillOpacity: 1
    },
    transform: "translate(543.6485,727.8408)",
    id: "g1434"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1436",
    style: {
      fill: "#ff9933",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 H 2.757 L 3.864,5.255 C 4.477,8.153 3.37,8.506 0.542,8.506 c -1.979,0 -3.888,0.024 -4.43,-2.591 h 2.757 c 0.165,0.754 0.636,0.918 1.32,0.918 1.201,0 1.154,-0.494 0.989,-1.272 L 0.895,4.218 H 0.778 C 0.683,5.184 -0.542,5.16 -1.32,5.16 c -2.002,0 -3.181,-0.636 -3.605,-2.662 -0.447,-2.144 0.566,-2.616 2.498,-2.616 0.966,0 2.262,0.189 2.71,1.343 H 0.377 Z M -0.778,3.487 C 0.118,3.487 0.707,3.417 0.565,2.71 0.377,1.838 0,1.673 -1.155,1.673 c -0.424,0 -1.201,0 -1.013,0.919 0.165,0.778 0.707,0.895 1.39,0.895"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#ff9933",
      fillOpacity: 1
    },
    transform: "translate(551.99,736.2766)",
    id: "g1438"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1440",
    style: {
      fill: "#ff9933",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 -0.259,-1.178 h 0.118 c 0.542,0.99 1.649,1.272 2.592,1.272 1.178,0 2.356,-0.212 2.191,-1.649 H 4.76 c 0.4,1.202 1.626,1.649 2.686,1.649 1.956,0 2.781,-0.801 2.356,-2.757 L 8.577,-8.436 H 5.82 l 1.037,4.878 c 0.141,0.872 0.283,1.532 -0.778,1.532 -1.084,0 -1.437,-0.707 -1.626,-1.626 L 3.44,-8.436 H 0.683 l 1.084,5.114 c 0.142,0.777 0.189,1.296 -0.777,1.296 -1.131,0 -1.485,-0.613 -1.697,-1.626 L -1.72,-8.436 H -4.477 L -2.686,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#ff9933",
      fillOpacity: 1
    },
    transform: "translate(566.9058,727.8408)",
    id: "g1442"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1444",
    style: {
      fill: "#ff9933",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 h 2.757 l 1.131,5.255 c 0.613,2.898 -0.495,3.251 -3.322,3.251 -1.98,0 -3.889,0.024 -4.43,-2.591 h 2.757 c 0.164,0.754 0.636,0.918 1.319,0.918 1.202,0 1.155,-0.494 0.99,-1.272 L 0.919,4.218 H 0.801 C 0.707,5.184 -0.518,5.16 -1.296,5.16 c -2.003,0 -3.181,-0.636 -3.605,-2.662 -0.448,-2.144 0.565,-2.616 2.497,-2.616 0.967,0 2.263,0.189 2.71,1.343 H 0.401 Z M -0.754,3.487 C 0.141,3.487 0.73,3.417 0.589,2.71 0.401,1.838 0.024,1.673 -1.131,1.673 c -0.424,0 -1.202,0 -1.013,0.919 0.165,0.778 0.707,0.895 1.39,0.895"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "path1448",
    style: {
      fill: "#ff9933",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 573.6685,727.8408 h -2.757 l 1.767,8.436 h 2.781 z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAkamaiLogo);
export default __webpack_public_path__ + "static/media/AkamaiLogo.f39dc68784dc1af4403826703d25e788.svg";
export { ForwardRef as ReactComponent };